import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { setBmUnitId } from "@/features/bmInstructionsSlice/";
import { getBaseUrl } from "@/helpers/fetch.helpers";
import { getJwtToken } from "@/helpers/storage.helpers";
import type {
  BoaInstruction,
  InstructionQuery,
  MvarVoltInstruction,
  RcInstruction,
} from "@/pages/BMInstructions";

export const bmInstructionExchangeApi = createApi({
  reducerPath: "bmInstructionExchangeApi",
  baseQuery: fetchBaseQuery({
    baseUrl: getBaseUrl("/bm-instruction-exchange/api/"),
    prepareHeaders: (headers) => {
      headers.set("authorization", `Bearer ${getJwtToken()}`);
      return headers;
    },
  }),
  endpoints: (build) => ({
    getBmUnits: build.query<string[], void>({
      query: () => ({ url: "bmunits" }),
      transformResponse: (data: { bmUnits: string[] }) => data.bmUnits,
      async onCacheEntryAdded(_queryArg, api) {
        await api.cacheDataLoaded;
        const { data } = api.getCacheEntry();
        if (data) {
          api.dispatch(setBmUnitId(data[0] ?? ""));
        }
      },
    }),

    getBoaInstructions: build.query<BoaInstruction[], InstructionQuery>({
      query: (params) => ({ url: "/instructions/boas", params }),
      transformResponse: (data: { instructions: BoaInstruction[] }) =>
        data.instructions,
    }),

    getRcInstructions: build.query<RcInstruction[], InstructionQuery>({
      query: (params) => ({ url: "/instructions/rcs", params }),
      transformResponse: (data: { instructions: RcInstruction[] }) =>
        data.instructions,
    }),

    getMvarVoltInstructions: build.query<
      MvarVoltInstruction[],
      InstructionQuery
    >({
      query: (params) => ({ url: "/instructions/voltmvars", params }),
      transformResponse: (data: { instructions: MvarVoltInstruction[] }) =>
        data.instructions,
    }),
  }),
});

export const {
  useGetBmUnitsQuery,
  useGetBoaInstructionsQuery,
  useGetRcInstructionsQuery,
  useGetMvarVoltInstructionsQuery,
} = bmInstructionExchangeApi;
